import { NgModule } from '@angular/core';
import { DebounceInputDirective } from './debounde-input.directive';

@NgModule({
  declarations: [DebounceInputDirective],
  exports: [DebounceInputDirective],
})
export class DirectivesModule {}
